/** מיפוי מזהה פריט בסרגל תצוגות השיחות למפתח מונה לא נקרא ב־Redux */
export type ChatSidebarUnreadCountKey =
  | 'my-chats'
  | 'not-my-chats'
  | 'unassigned-chats'
  | 'bots-chats'
  | 'chats';

export function menuItemIdToUnreadCountKey(menuItemId: string | undefined): ChatSidebarUnreadCountKey | undefined {
  switch (menuItemId) {
    case 'awaiting-me':
    case 'newly-assigned':
    case 'waiting-customer':
    case 'my-chats-snoozed':
    case 'my-chats':
      return 'my-chats';
    case 'not-my-chats':
      return 'not-my-chats';
    case 'unassigned-chats':
      return 'unassigned-chats';
    case 'bots-chats':
      return 'bots-chats';
    case 'chats':
      return 'chats';
    case 'chats-completed':
      return undefined;
    default:
      return undefined;
  }
}
